import styled, { css } from 'styled-components'

import { TEXT_GREY } from '@CSSVars/colors'


export const _Disclaimer = styled.p`
  color: ${TEXT_GREY};
`

export const collapseContainerCss = css`
  margin-bottom: 24px;
`
